import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import getters from './getters'
import liveChat from './modules/liveChat'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    common,
    liveChat
  },
  getters
})
